import { message } from 'src/common/components/message';
import { getCurrentSpaceId } from 'src/hooks/space/get-space';
import { Modals } from 'src/modals';
import { appI18n } from '@flowus/common/i18n';

import { emitter } from '@flowus/common/utils/emitter';
import { getLimitConfig } from '../app/hook/subscription-data';

export const checkIsMaximumCapacityDialog = (spaceId = getCurrentSpaceId()) => {
  const isCurrentSpace = spaceId === getCurrentSpaceId();
  const capacity = getLimitConfig(spaceId);

  if (capacity.blocksIsMax) {
    if (isCurrentSpace) {
      emitter.emit('modalId', { modalId: Modals.MAXIMUM_CAPACITY_DIALOG, spaceId });
    } else {
      message.error(appI18n.t('common.target_capacity_reached') as string);
    }
    throw new Error(
      appI18n.t('components.services.capacity.blocks_reached_maximum_limit') as string
    );
  }
};
